import common_translations from "../common.json";
import apac from "./apac.translation.json";
import app from "./app.json";
import bootstrap from "./bootstrap.translation.json";
import checkout from "./checkout.json";
import commbankAu from "./commbank-au.translation.json";
import corporate_demo from "./corporate-demo.translation.json";
import exchange from "./exchange.json";
import fintech from "./fintech.json";
import flights from "./flights.json";
import hotels from "./hotels.json";
import hsbcIn from "./hsbc-in.translation.json";
import hsbcSg from "./hsbc-sg.translation.json";
import lloyds from "./lloyds.translation.json";
import trips from "./trips.json";
import ui from "./ui.json";
import wallet from "./wallet.json";

const bundle = {
  ...common_translations,
  ...app,
  ...checkout,
  ...exchange,
  ...fintech,
  ...flights,
  ...hotels,
  ...trips,
  ...ui,
  ...wallet,
};
export default bundle;

export const enGB_defaultTranslations = bundle;

export const enGB_apacTranslations = apac;

export const enGB_commbankAuTranslations = commbankAu;

export const enGB_hsbcSgTranslations = hsbcSg;

export const enGB_hsbcInTranslations = hsbcIn;

export const enGB_lloydsTranslations = lloyds;

export const enGB_bootstrapTranslations = bootstrap;
export const enGB_corporateDemoTranslations = corporate_demo;
